import * as tslib_1 from "tslib";
import { AfterViewInit, ChangeDetectorRef, ElementRef, EventEmitter, ViewContainerRef } from '@angular/core';
import { ESRI } from '../../../../esri-loader-util';
import { BooleanConverter, InputConverter, JSONConverter } from '../../../../inputConverter';
import { LayerService } from '../../../../services/layer.service';
import { BaseComponent } from '../../../base.component';
var Point;
var degreeName = 'degrees (long/lat)';
var degreeReverseName = 'degrees (lat/long)';
var CoordinatesComponent = /** @class */ (function (_super) {
    tslib_1.__extends(CoordinatesComponent, _super);
    function CoordinatesComponent(_vcr, changeDetectorRef, layerService) {
        var _this = _super.call(this, _vcr) || this;
        _this.changeDetectorRef = changeDetectorRef;
        _this.layerService = layerService;
        _this._active = false;
        _this.activeChange = new EventEmitter();
        _this._currentMode = 'live';
        _this.formatSort = [degreeReverseName, degreeName, 'dd', 'ddm', 'dms', 'mgrs', 'usng', 'utm'];
        _this.currentLocationX = null;
        _this.currentLocationY = null;
        _this.autoCreateLayer = false;
        _this.sorting = false;
        _this.unloadListner = function () {
            _this.deactivate();
        };
        _this.registerEvent('activeChange', _this.activeChange);
        return _this;
    }
    Object.defineProperty(CoordinatesComponent.prototype, "active", {
        get: function () { return this._active; },
        /**
         * Overall state of the component. Values: true = User may use tool, false = tool is inactive.
         */
        set: function (value) {
            this._active = BooleanConverter(value);
            value ? this.activate() : this.deactivate();
            this.activeChange.emit(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CoordinatesComponent.prototype, "currentMode", {
        get: function () {
            return this._currentMode;
        },
        set: function (value) {
            this._currentMode = value;
            if (this.coordinateConversionTool) {
                this.coordinateConversionTool.mode = this._currentMode;
            }
        },
        enumerable: true,
        configurable: true
    });
    CoordinatesComponent.prototype.ngAfterViewInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.setupMapViewRef(null)];
                    case 1:
                        _a.mapRef = _b.sent();
                        return [4 /*yield*/, ESRI.Point];
                    case 2:
                        Point = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CoordinatesComponent.prototype.createTool = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, customView, containerNode;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, Promise.all([ESRI.CoordinateWidget, ESRI.CoordinateWidgetViewModel, ESRI.PictureMarker, ESRI.Format])];
                    case 1:
                        _a = tslib_1.__read.apply(void 0, [_b.sent(), 4]), this.coordWidgetConstructor = _a[0], this.coordWidgetViewModel = _a[1], this.pictureMarkerConstructor = _a[2], this.formatConstructor = _a[3];
                        this.markerSymbol = new this.pictureMarkerConstructor({
                            url: 'https://static.arcgis.com/images/Symbols/Cartographic/esriCartographyMarker_70_White.png',
                            height: 24,
                            width: 24,
                            xoffset: 0,
                            yoffset: 12
                        });
                        customView = new this.coordWidgetViewModel({
                            locationSymbol: this.markerSymbol,
                            view: this.mapRef
                        });
                        containerNode = document.createElement('div');
                        this.coordinatesContainer.nativeElement.append(containerNode);
                        this.coordinateConversionTool = new this.coordWidgetConstructor({
                            container: containerNode,
                            orientation: 'expand-down',
                            view: this.mapRef,
                            viewModel: customView
                        });
                        this.coordinateConversionTool.formats.on('before-add', function (e) {
                            switch (e.item.name) {
                                case 'dms':
                                    _this.modifyDMSFormat(e.item);
                                    break;
                                case 'xy':
                                    _this.modifyXYFormat(e.item);
                                    _this.duplicateDegrees(e.item);
                                    break;
                                case 'basemap':
                                    e.preventDefault();
                                    break;
                                default:
                                    break;
                            }
                        });
                        this.coordinateConversionTool.formats.on('after-add', function (_e) {
                            if (_this.coordinateConversionTool.formats.length === _this.formatSort.length && !_this.sorting) {
                                _this.sorting = true;
                                _this.coordinateConversionTool.formats.sort(function (a, b) {
                                    var aIndex = _this.formatSort.indexOf(a.name.toLowerCase());
                                    var bIndex = _this.formatSort.indexOf(b.name.toLowerCase());
                                    if (aIndex < bIndex) {
                                        return -1;
                                    }
                                    else if (aIndex > bIndex) {
                                        return 1;
                                    }
                                    return 0;
                                });
                                _this.sorting = false;
                            }
                        });
                        if (!this.mapClickListener) {
                            this.mapClickListener = this.mapRef.on('click', function () {
                                if (_this.autoCreateLayer && _this.coordinateConversionTool) {
                                    _this.createCoordinateLayer();
                                }
                            });
                        }
                        this.coordinateConversionTool.watch(['mode', 'currentLocation'], function (newValue, _oldValue, propertyName) {
                            if (propertyName === 'mode') {
                                _this._currentMode = newValue;
                            }
                            //
                            if (propertyName === 'currentLocation') {
                                var current = newValue;
                                if (!current) {
                                    _this.currentLocationX = null;
                                    _this.currentLocationY = null;
                                }
                                else {
                                    _this.currentLocationX = current.x;
                                    _this.currentLocationY = current.y;
                                }
                            }
                            _this.changeDetectorRef.detectChanges();
                        });
                        window.addEventListener('unload', this.unloadListner);
                        this.coordinateConversionTool.when(function () {
                            var dropdownButton = _this.coordinatesContainer.nativeElement.querySelector('.esri-coordinate-conversion__tools > li.esri-widget--button');
                            dropdownButton.dispatchEvent(new MouseEvent('click', { bubbles: false }));
                            if (_this.currentMode !== _this.coordinateConversionTool.mode) {
                                var duration = 1000;
                                setTimeout(function () {
                                    _this.coordinateConversionTool.mode = _this.currentMode;
                                }, duration);
                            }
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    CoordinatesComponent.prototype.modifyXYFormat = function (latLongFormat) {
        latLongFormat.name = degreeName;
        latLongFormat.defaultPattern = latLongFormat.currentPattern = 'X, Y';
        latLongFormat.conversionInfo = {
            reverseConvert: function (input) {
                var retVal = null;
                var _a = tslib_1.__read(input.split(',').map(function (p) { return parseFloat(p.trim()); }), 2), x = _a[0], y = _a[1];
                if (x && y) {
                    retVal = new Point({ longitude: x, latitude: y });
                }
                return retVal;
            },
            convert: function (input) {
                return { location: input, coordinate: [input.longitude, input.latitude].join(', ') };
            }
        };
    };
    CoordinatesComponent.prototype.duplicateDegrees = function (latLongFormat) {
        this.coordinateConversionTool.formats.add(new this.formatConstructor({
            conversionInfo: {
                reverseConvert: function (input) {
                    var retVal = null;
                    var _a = tslib_1.__read(input.split(',').map(function (p) { return parseFloat(p.trim()); }), 2), y = _a[0], x = _a[1];
                    if (x && y) {
                        retVal = new Point({ longitude: x, latitude: y });
                    }
                    return retVal;
                },
                convert: function (input) {
                    return { location: input, coordinate: [input.latitude, input.longitude].join(', ') };
                }
            },
            coordinateSegments: tslib_1.__spread(latLongFormat.coordinateSegments).reverse(),
            currentPattern: 'Y, X',
            defaultPattern: 'Y, X',
            name: degreeReverseName
        }));
    };
    CoordinatesComponent.prototype.modifyDMSFormat = function (dmsFormat) {
        var parseFix = (function (val) { return parseFloat(val).toFixed(); });
        dmsFormat.coordinateSegments.find(function (cs) { return cs.alias === 'D'; }).substitution.output = parseFix;
        dmsFormat.coordinateSegments.find(function (cs) { return cs.alias === 'B'; }).substitution.output = parseFix;
        dmsFormat.coordinateSegments.find(function (cs) { return cs.alias === 'X'; }).substitution.output = parseFix;
        dmsFormat.coordinateSegments.find(function (cs) { return cs.alias === 'Y'; }).substitution.output = parseFix;
        dmsFormat.defaultPattern = dmsFormat.currentPattern = "X\u00B0C'D\"E, Y\u00B0A'B\"N";
        var degreeConversion = (function (val) {
            var minutesPerHour = 60;
            var secondsPerHour = 3600;
            var degrees = parseFloat(val.slice(0, val.indexOf('°') - 1));
            var minutes = parseFloat(val.slice(val.indexOf('°') + 1, val.indexOf("'") - 1));
            var seconds = parseFloat(val.slice(val.indexOf("'") + 1, val.indexOf('"') - 1));
            var hemisphere = val.slice(val.indexOf('"') + 1).trim().toLowerCase();
            var decimalDegrees = degrees + (minutes / minutesPerHour) + (seconds / secondsPerHour);
            if (hemisphere === 'w' || hemisphere === 's') {
                decimalDegrees = -Math.abs(decimalDegrees);
            }
            return decimalDegrees;
        });
        dmsFormat.conversionInfo = {
            reverseConvert: function (input) {
                var retVal = null;
                // TODO: Currently broken in ESRI JS API, revisit when updated
                // Before the input is passed here it is parsed by ESRI's code to something unusable
                // Unmodified version is broken as well, though that appears to just have swapped coordinates
                var _a = tslib_1.__read(input.split(',').map(function (p) { return p.trim(); }), 2), x = _a[0], y = _a[1];
                if (x && y
                    && x.includes('°') && x.includes("'") && x.includes('"')
                    && y.includes('°') && y.includes("'") && y.includes('"')) {
                    var convertedX = degreeConversion(x);
                    var convertedY = degreeConversion(y);
                    if (convertedX && convertedY) {
                        retVal = new Point({ longitude: convertedX, latitude: convertedY });
                    }
                }
                return retVal;
            }
        };
    };
    CoordinatesComponent.prototype.createCoordinateLayer = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var graphic, point, newGraphic, graphicsLayer;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ESRI.Graphic];
                    case 1:
                        graphic = _a.sent();
                        point = {
                            type: 'point',
                            longitude: this.coordinateConversionTool.currentLocation.longitude,
                            latitude: this.coordinateConversionTool.currentLocation.latitude
                        };
                        newGraphic = new graphic({
                            geometry: point,
                            symbol: {
                                type: 'simple-marker',
                                color: [0, 128, 255],
                                size: 14
                            }
                        });
                        return [4 /*yield*/, this.layerService.addGraphicsLayer({
                                title: "Location: " + this.coordinateConversionTool.conversions.getItemAt(0).displayCoordinate
                            })];
                    case 2:
                        graphicsLayer = _a.sent();
                        graphicsLayer.add(newGraphic);
                        this.layerService.mapLayersSub.next();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Make the tool active/shown.
     */
    CoordinatesComponent.prototype.activate = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                if (!this.coordinateConversionTool) {
                    this.createTool();
                }
                return [2 /*return*/];
            });
        });
    };
    /**
     * Make the tool inactive/hidden.
     */
    CoordinatesComponent.prototype.deactivate = function () {
        if (this.coordinateConversionTool) {
            this.coordinateConversionTool.destroy();
            this.coordinateConversionTool = null;
        }
        window.removeEventListener('unload', this.unloadListner);
        if (this.mapClickListener) {
            this.mapClickListener.remove();
            this.mapClickListener = null;
        }
    };
    tslib_1.__decorate([
        InputConverter(JSONConverter),
        tslib_1.__metadata("design:type", Object)
    ], CoordinatesComponent.prototype, "formatSort", void 0);
    return CoordinatesComponent;
}(BaseComponent));
export { CoordinatesComponent };
